import { render, staticRenderFns } from "./reciept-preview.vue?vue&type=template&id=7832ab0c&scoped=true&"
import script from "./reciept-preview.vue?vue&type=script&lang=js&"
export * from "./reciept-preview.vue?vue&type=script&lang=js&"
import style0 from "./reciept-preview.vue?vue&type=style&index=0&id=7832ab0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7832ab0c",
  null
  
)

export default component.exports